import React from 'react'
import { HiPhone } from 'react-icons/hi'
import CopyButton from './CopyButton'
import PropTypes from 'prop-types'

const PhoneWithCopy = ({ phone, label = 'Phone', className, successMessage = 'Mobile Copied' }) => {
    const displayPhone = phone && phone !== '-' ? phone : '-'
    const showCopy = displayPhone !== '-'

    return (
        <div className={`flex items-center ${className || ''}`}>
            <HiPhone className="w-4 h-4 text-gray-500 mr-2" />
            <span>
                <span className="font-semibold text-gray-900">{label}:</span> {displayPhone}
            </span>
            {showCopy && (
                <CopyButton
                    text={displayPhone}
                    tooltipTitle="Copy mobile"
                    successMessage={successMessage}
                    className="ml-2"
                />
            )}
        </div>
    )
}

PhoneWithCopy.propTypes = {
    phone: PropTypes.string,
    label: PropTypes.string,
    className: PropTypes.string,
    successMessage: PropTypes.string
}

export default PhoneWithCopy
